"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Avatar as AvatarBase } from "@base-ui/react/avatar";
import { cva } from "class-variance-authority";
import { cn } from "../lib/utils.js";
const avatarVariants = cva("relative flex shrink-0 overflow-hidden rounded-full", {
    variants: {
        size: {
            sm: "size-8 text-sm",
            md: "size-10",
            lg: "size-12 text-lg",
        },
    },
    defaultVariants: {
        size: "md",
    },
});
function Avatar({ className, size, ...props }) {
    return (_jsx(AvatarBase.Root, { "data-slot": "avatar", className: cn(avatarVariants({ size }), className), ...props }));
}
function AvatarImage({ className, ...props }) {
    return (_jsx(AvatarBase.Image, { "data-slot": "avatar-image", className: cn("size-full object-cover", className), ...props }));
}
function AvatarFallback({ className, ...props }) {
    return (_jsx(AvatarBase.Fallback, { "data-slot": "avatar-fallback", className: cn("bg-muted flex size-full items-center justify-center rounded-full select-none", className), ...props }));
}
export { Avatar, AvatarImage, AvatarFallback };
//# sourceMappingURL=Avatar.js.map